import useSWR from 'swr'

import { useAuthToken } from '@/hooks/useAuthToken'
import type { ApiError } from '@/services/api'
import { createFetcher } from '@/services/api'
import { coachMessagesService } from '@/services/coachMessagesService'
import type { MyCoach } from '@/types/coachMessages'

/** Who is coaching the signed-in learner, and whether coaching is on for them. Polled so a change needs no new login. */
export function useMyCoach(learnerUserId: string | null) {
  const { getToken, isSignedIn } = useAuthToken()
  const enabled = isSignedIn && Boolean(learnerUserId)

  const { data, error, isLoading } = useSWR<MyCoach, ApiError>(
    enabled && learnerUserId ? coachMessagesService.getMyCoachUrl(learnerUserId) : null,
    createFetcher(getToken),
    { refreshInterval: 60_000 }
  )

  return {
    coach: data ?? null,
    isLoading,
    loadError: error ?? null,
  }
}
